$(function () {
  $('.template-collection .collapsible__menu').each(function () {
    var $collapsibleMenu = $(this);
    $collapsibleMenu.find('.squeezhead').on('click', function (e) {
      var isMobile = $(window).width() < 1024;
      if (!isMobile && $(e.target).hasClass('link') && $(e.target).attr('href').indexOf('#') != 0) {
        var $link = $(this).find('.link');
        if ($link.length) {
          window.location.href = $link.attr('href');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      } else {
        var othersOpen = $collapsibleMenu.find('.squeezebox--open');
        if ($(this).closest('.squeezebox:not(.squeezebox--open)').length > 0) {
          othersOpen.each(function () {
            var opener = $(this).find('.squeezhead')[0];
            opener.click();
          });
        }
      }
    });
  });

  $('.collection__sidebar').each(function () {
    var $sidebar = $(this);
    var $header = $('.collection-header');
    var margin = $header.outerHeight() - 15;
    $sidebar.css({ marginTop: -margin });
  });

  //script to bring the scroll to highlighted item
  $(window).load(function () {
    $('.collection__sidebar .collapsible__menu').each(function () {
      var $collapsibleMenu = $(this);
      var $openElement = $collapsibleMenu.find('.squeezebox--open');
      if ($openElement.length > 0) {
        var offset = $openElement.offset().top + $openElement.height() - $collapsibleMenu.offset().top - $collapsibleMenu.height();
        if (offset > 0) $collapsibleMenu.scrollTop(offset);
      }
    });
  });
});
